import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function SkeletonLoadingBox(props) {
    const style = {
        ...props.style,
        maxWidth: '100%',
        maxHeight: 'auto',
        width: props.width || 'auto',
        height: props.height || 'auto',
    };

    const extraClassNames = props.className || '';

    return (
        <React.Fragment>
            <div
                className={classnames(
                    'skeleton-loading skeleton-loading--box',
                    extraClassNames
                )}
                style={style}
            />
        </React.Fragment>
    );
}

// default props
SkeletonLoadingBox.defaultProps = {
    width: 'auto',
    height: 'auto',
};

// validate props
SkeletonLoadingBox.propTypes = {
    width: PropTypes.any.isRequired,
    height: PropTypes.any.isRequired,
};

export default SkeletonLoadingBox;
